import Autocomplete from '@material-ui/lab/Autocomplete';
import { fontFamily, colors } from './GlobalStyle';
import styled from 'styled-components';

export const StyledAutoComplete = styled(Autocomplete)`
  && .MuiAutocomplete-inputRoot {
    color: white;
    position: relative;
    width: 100%;
    height: 60px;
    background: transparent !important;
    border: none;
    border-bottom: 2px solid ${colors.yellow};
    font-weight: ${fontFamily.primary.black.fontWeight};
    color: ${colors.white}!important;
    caret-color: ${colors.white};
    outline: none;
    text-transform: uppercase;
  }

  && .MuiInput-underline {
    &:after {
      border-bottom: 2px solid white;
      opacity: 0;
      width: 0;
      transition: all 0.6s;
      transform: translate(0, 100%);
    }

    &.Mui-focused {
      &:after {
        width: 100%;
        opacity: 1;
      }
    }
  }

  && .MuiFormLabel-filled {
    ~ .MuiInput-underline {
      &:after {
        width: 100%;
        opacity: 1;
      }
    }
  }

  && .MuiAutocomplete-input {
    margin-top: 10px;
    font-family: ${fontFamily.primary.black.fontFamily};
    color: ${colors.white};
    font-weight: ${fontFamily.primary.black.fontWeight};
  }

  && .MuiAutocomplete-root {
    color: white;
    position: relative;
    width: 100%;
    height: 60px;
    background: transparent !important;
    border: none;
    border-bottom: 2px solid red;
    font-weight: ${fontFamily.primary.black.fontWeight};
    color: ${colors.white}!important;
    caret-color: ${colors.white};
    outline: none;
    text-transform: uppercase;
  }

  && .MuiFormLabel-root {
    font-family: ${fontFamily.primary.black.fontFamily};
    color: ${colors.white};
    text-transform: uppercase;
    font-weight: ${fontFamily.primary.black.fontWeight};
  }

  && .MuiFormLabel-filled {
    color: ${colors.yellow};
  }

  ~ .MuiAutocomplete-popper .MuiAutocomplete-paper {
    position: absolute;
    top: 30px;
    width: 100%;
    max-height: 350px;
    background-color: ${colors.black};
    color: #999;
    font-weight: ${fontFamily.primary.black.fontWeight};
    font-family: ${fontFamily.primary.black.fontFamily};
    text-transform: uppercase;
  }

  && .MuiAutocomplete-clearIndicator {
    display: none;
  }

  && .MuiAutocomplete-popupIndicator {
    display: none;
  }

  && .MuiFormLabel-root {
    margin-top: 20px;

    &.Mui-focused {
      color: ${colors.yellow};
    }
  }

  ~ .MuiAutocomplete-popper .MuiAutocomplete-paper .MuiAutocomplete-listbox {
    max-height: 350px;
  }

  ~ .MuiAutocomplete-popper
    .MuiAutocomplete-paper
    .MuiAutocomplete-listbox
    .MuiAutocomplete-option {
    margin-bottom: 5px;
    line-height: 30px;
    border: 2px solid #232323;
    border-radius: 2px;
    padding: 15px 20px;
    background-color: ${colors.darkGrey};
  }

  ~ .MuiAutocomplete-popper
    .MuiAutocomplete-paper
    .MuiAutocomplete-listbox
    .MuiAutocomplete-option[data-focus='true'] {
    color: ${colors.white};
  }

  ~ .MuiAutocomplete-popper
    .MuiAutocomplete-paper
    .MuiAutocomplete-listbox
    .MuiAutocomplete-option[data-focus='true']
    .suggestion-details {
    color: #dbdbdb;
  }

  ~ .MuiAutocomplete-popper .MuiAutocomplete-paper .MuiAutocomplete-noOptions {
    display: none;
  }
`;
